<script setup lang="ts" generic="T extends Record<string, any>">
const props = defineProps<{ items: T }>();
</script>

<template>
    <div class="w-full flex-center flex-col gap-8">
        <div
            v-for="item in items"
            :key="item.title"
            class="w-full py-8 flex-center flex-col gap-8"
        >
            <div class="w-full flex-center flex-col gap-7">
                <h3 class="text-start w-full">{{ item.title }}</h3>
                <div
                    v-for="group in item.groups"
                    :key="group.title"
                    class="w-full flex-center flex-col gap-3"
                    data-aos="zoom-in" 
                    data-aos-duration="1000"
                >
                    <div class="w-full flex items-center gap-3">
                        <Icon name="solar:check-circle-bold" class="text-secondary-600" size="24" />
                        <h4 class="text-gray-600/80">{{ group.title }}</h4>
                    </div>
                    <p class="w-full text-gray-500 text-body2 pr-9">{{ group.desc }}</p>
                </div>
            </div>
            <div 
                data-aos="fade-up" 
                data-aos-duration="1000"
                class="w-full aspect-square flex-center bg-primary-50 rounded-xl border-2 border-gray-300/50"
            >
                <img
                    :src="item.img"
                    :alt="item.title"
                    class="w-full"
                    loading="lazy"
                />
            </div>
        </div>
    </div>
</template>
